import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import {immutableMove} from 'util/ImmutableListUtil';
import BioentityWorklistItems from 'worklists/BioentityWorklistItems';
import ContainerWorklistItems from 'worklists/ContainerWorklistItems';
import PlateWorklistItems from 'worklists/PlateWorklistItems';
import {dispatchUpdateWorklist} from 'worklists/WorklistActions';
import {WorklistType} from 'worklists/WorklistConstants';

import {WorklistSummaryGraphQL} from '../../graphql-fragments/worklists/__generated/WorklistSummaryGraphQL';

export interface ReorderWorklistModalProps {
  onRequestClose: () => void;
  worklist: WorklistSummaryGraphQL;
  itemIds: Array<string>;
}

export default function ReorderWorklistModal(props: ReorderWorklistModalProps): JSX.Element {
  const [itemIds, setItemIds] = useState<Array<string>>(props.itemIds);

  function handleSubmit(): void {
    dispatchUpdateWorklist(props.worklist.id, {itemIds}, {refreshWorklistItemsSearch: true});
    props.onRequestClose();
  }

  function _handleReorderRow(id: string, newIndex: number): void {
    setItemIds(immutableMove(itemIds, id, newIndex));
  }

  function _renderWorklistItems(): JSX.Element {
    switch (props.worklist.itemType) {
      case WorklistType.CONTAINER:
        return <ContainerWorklistItems itemIds={itemIds} onReorderRow={_handleReorderRow} />;
      case WorklistType.BIOENTITY:
        return <BioentityWorklistItems itemIds={itemIds} onReorderRow={_handleReorderRow} />;
      case WorklistType.PLATE:
        return <PlateWorklistItems itemIds={itemIds} onReorderRow={_handleReorderRow} />;
      default:
        throw new Error(`Unknown worklist item type ${props.worklist.itemType}`);
    }
  }

  return (
    <Modal
      onRequestClose={props.onRequestClose}
      onRequestSubmit={handleSubmit}
      title="Reorder worklist items"
      large={true}
      buttons={[
        {
          text: 'Save',
          submit: true,
          style: ButtonStyle.SECONDARY,
        },
      ]}
    >
      <div>
        <div>
          <label className="fieldLabel-label">Worklist order</label>
        </div>
        <div className={css(styles.scrollableItemsListing)}>{_renderWorklistItems()}</div>
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  scrollableItemsListing: {
    maxHeight: '60vh',
    overflowY: 'scroll',
    // Chrome (not sure about other browsers) doesn't respect overflow-x when overflow-y is "scroll". The drag
    // handle on reorderable list rows is outside of the bounding box, so it doesn't show up when overflow-x
    // is not "visible". padding-left:24px;margin-left:-24px; works around this by keeping it in the box.
    paddingLeft: '24px',
    marginLeft: '-24px',
  },
});
